import { Component, OnInit, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { AcademyService } from "../academies/service/academies.service";
import { BatchService } from "src/app/services/batch.service";
import { ReportService } from "src/app/services/report.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class AttendanceComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  batchList: any;
  months = environment.months;
  batchPlayers: any = [];
  yearlist: any = [];
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadAttendanceReportList: any;
  searchby;
  public hide: boolean = true;
  academiesList: any;
  academyId: any;
  attendanceReportsData: Object;
  batch:any;
  username: string;
  year:number;
  month:number;

  constructor(
    private messageService: MessageService,
    private academyService: AcademyService,
    private batchService: BatchService,
    private reportService: ReportService
  ) {}

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.downloadFlg = false;
    var currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= 2040; i++) {
      this.yearlist.push({ label: i, value: i });
    }
    this.getAcademies();
  }

  
  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getBatchList(event) {
    const academyId = event.value;
    if (academyId !== null) {
      let query = "filterByDisable=false&filterByStatus=true&filterByAcademyId=" + academyId;
      this.batchService.getBatchList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.batchList = data?.data?.items;
      }, err => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Batch Player failed', life: 6000 });
      })
    } else {
      this.onClearAcademySelection(event);
    }
    this.loadAttendance(this.lastTableLazyLoadEvent);
  }

  getBatchPlayer(event) {
    this.batchPlayers = event.value.batchPlayers;
    this.loadAttendance(this.lastTableLazyLoadEvent);
  }
  
  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.academyId = null;
    this.batch = null;
    this.username = null;
    this.month = null;
    this.year = null;
    this.batchList = [];
    this.batchPlayers = [];
    this.loadAttendance(this.lastTableLazyLoadEvent);
  }

  onClearAcademySelection(event) {
    this.batchList = [];
    this.batchPlayers = [];
    this.batch = null;
    this.username = null;
  }

  onClearBatchSelection(event) {
    this.batchPlayers = [];
    this.username = null;
  }

  loadAttendance(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
        params += "&filterByDate=" + this.searchby.value;
        params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
        params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    if (this.batch) {
      params += "&filterByBatch=" + this.batch.id;
    }

    if (this.username) {
      params += "&filterByUsername=" + this.username;
    }

    if (this.month) {
      params += "&filterByMonth=" + this.month;
    }
    
    if (this.year) {
      params += "&filterByYear=" + this.year;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getAttendanceReport(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data:any) => {
         if (this.downloadFlg === false) {
          this.attendanceReportsData = data.data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportAttendanceReportListData(data.data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAttendance(this.lastTableLazyLoadEvent);
  }

  async exportAttendanceReportListData(activeUserReportList) {
    this.downloadAttendanceReportList = activeUserReportList;
    this.downloadAttendanceReportList.forEach(ele => {
      if (ele.lastAttendedDate) {
        ele.lastAttendedDate = moment(ele.lastAttendedDate).format("DD-MM-YYYY");
      }
    })
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadAttendanceReportList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Attendance_Report");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
